export const SUPPORTS_RELATIVE_TIME_FORMAT = "RelativeTimeFormat" in Intl;
